import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-spacer',
  template: `
    <span class="spacer" style="display: inline-block; width: 1em;"></span>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpacerComponent {}
